// App.tsx
import React, { useEffect, useState } from 'react'
import './App.css'
import { AppRouter } from './router'
import { store } from './store/store'
import { Provider } from 'react-redux'
import * as Amplify from 'aws-amplify'
import { AwsConfig } from './constants/aws-exports'
import { BrowserRouter } from 'react-router-dom'
import { ConfigProvider } from 'antd'
import heIL from 'antd/lib/locale/he_IL'
import { ThemeProvider } from 'styled-components'
import { getTheme } from 'styles/theme'
import { I18nextProvider } from 'react-i18next'
import i18n from 'translation/i18n'
import { ELanguage } from 'types/enums/ELanguage'
import GlobalStyle from 'styles/GlobalStyle'

Amplify.Amplify.configure(AwsConfig)

const App: React.FC = () => {
  const [theme, setTheme] = useState(getTheme(i18n.language as ELanguage))

  useEffect(() => {
    const handleLanguageChange = (lang: ELanguage) => {
      setTheme(getTheme(lang))
    }

    i18n.on('languageChanged', handleLanguageChange)

    return () => {
      i18n.off('languageChanged', handleLanguageChange)
    }
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <ConfigProvider direction="rtl" locale={heIL}>
        <Provider store={store}>
          <I18nextProvider i18n={i18n}>
            <GlobalStyle />
            <BrowserRouter>
              <AppRouter />
            </BrowserRouter>
          </I18nextProvider>
        </Provider>
      </ConfigProvider>
    </ThemeProvider>
  )
}

export default App
